import { useContext, useEffect, useState } from "react";
import { Modal, Form, Select, Button, Typography } from "antd";
import { useParams } from "react-router-dom";
import { GetAllOpportunitiesPanelsByCompanyAPI } from "../../../API/OpportunitiesPanelsAPI";
import { OpportunitiesPanelsModel } from "../../../Models/OpportunitiesPanelsModel";
import { BanksModel } from "../../../Models/BanksModel";
import { GetAllBanks } from "../../../API/BanksAPI";
import { CreateRegister } from "../../../API/RegisterAPI";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Contexts/AuthContext";
import Loader from "../../Shared/Loader";
import "./styles.css";

const { Title } = Typography;
interface CreateRegisterModalProps {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    getRegisters: () => void;
}

export const CreateRegisterModal: React.FC<CreateRegisterModalProps> = ({ showModal, setShowModal, getRegisters }) => {
    const { userEmail } = useContext(AuthContext);
    const [opportunityPanels, setOpportunityPanels] = useState<OpportunitiesPanelsModel[]>([]);
    const { id } = useParams<{ id: string }>();
    const [banks, setBanks] = useState<BanksModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        GetAllOpportunitiesPanelsByCompanyAPI(id ?? "").then(response => {
            setOpportunityPanels(response.data);
        });
        GetAllBanks().then(response => {
            setBanks(response.data);
        });
    }, [id]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const submitRegisterForm = async (values: { panel: string; bank: string }) => {
        setLoading(true);
        const { panel, bank } = values;
        try {
            await CreateRegister(id ?? "", panel, bank, userEmail);
            toast.success("Registro criado com sucesso!");
            setShowModal(false);
            getRegisters();
        } catch (err) {
            toast.error(String(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            className="create-register-modal"
            title="Informações iniciais"
            open={showModal}
            onCancel={handleCloseModal}
            footer={null}
        >
            {loading && <Loader />}
            <Form form={form} layout="vertical" onFinish={submitRegisterForm}>
                <Form.Item
                    label="Selecione o Painel Correspondente:"
                    name="panel"
                    rules={[{ required: true, message: "Por favor, selecione um painel!" }]}
                    validateTrigger={["onBlur", "onSubmit"]}
                >
                    <Select placeholder="Selecione..." allowClear>
                        {opportunityPanels.map(panel => (
                            <Select.Option key={panel.id} value={panel.id}>
                                {panel.name} - {panel.year}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Selecione o Tipo de Formulário:"
                    name="bank"
                    rules={[{ required: true, message: "Por favor, selecione um banco!" }]}
                    validateTrigger={["onBlur", "onSubmit"]}
                >
                    <Select placeholder="Selecione..." allowClear>
                        {banks.map(bank => (
                            <Select.Option key={bank.id} value={bank.id}>
                                {bank.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <div className="modal-buttons">
                    <Button onClick={handleCloseModal}>Cancelar</Button>
                    <Button type="primary" htmlType="submit">Continuar</Button>
                </div>
            </Form>
        </Modal>
    );
};